import { render, staticRenderFns } from "./HC_helpInfo.vue?vue&type=template&id=82b63952&scoped=true&"
import script from "./HC_helpInfo.vue?vue&type=script&lang=js&"
export * from "./HC_helpInfo.vue?vue&type=script&lang=js&"
import style0 from "./HC_helpInfo.vue?vue&type=style&index=0&id=82b63952&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b63952",
  null
  
)

export default component.exports